import {AppBar, Box, Toolbar, IconButton, Stack, Tooltip, styled, type AppBarProps} from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import {AppTopBarMainPanel} from './components/AppTopBarMainPanel/AppTopBarMainPanel';
import {AppTopBarMoreMenu} from './components/AppTopBarMoreMenu';
import {type IntercomProps, useIntercom} from 'react-use-intercom';
import {useAuth0} from '@auth0/auth0-react';
import {useTranslation} from 'react-i18next';
import {AppTopBarNotificationList} from './components/AppTopBarMainPanel/components/AppTopBarNotifications';
import {AppTopBarProfileMenu} from './components/AppTopBarProfileMenu';
import {APP_TOP_BAR_HEIGHT} from '../../../appConstants';
import {EMPTY_ID, useGetMe} from 'hooks/swr';
import {useRefreshApplication} from 'hooks/useRefreshApplication';

interface IMenuItem {
  title: string;
  icon: JSX.Element;
  onClick: (event: any) => void;
}

export const AppTopBar = () => {
  const {t} = useTranslation('common');
  const {boot} = useIntercom();
  const {user} = useAuth0();
  const {data: me} = useGetMe({resourceId: EMPTY_ID});
  useRefreshApplication();

  const intercomProps: IntercomProps = {
    userId: user?.sub,
    email: user?.email,
    name: me?.fullname,
    userHash: me?.intercomHash,
    customLauncherSelector: '#intercomLauncherSelector',
  };

  return (
    <AppBarBioplan
      elevation={0}
      id="onboarding-main-top-bar"
      position="fixed"
      sx={{zIndex: (theme) => theme.zIndex.drawer + 1, maxHeight: APP_TOP_BAR_HEIGHT}}
    >
      <ToolbarBioplan>
        <AppTopBarMainPanel />
        <Box flexGrow={1} />
        <Stack direction="row" spacing={1}>
          <AppTopBarNotificationList />
          <AppTopBarMoreMenu />

          <Tooltip title={t('contactSupportBtnTooltip') ?? ''}>
            <IconButton
              id="intercomLauncherSelector"
              color="inherit"
              onClick={() => {
                boot(intercomProps);
              }}
            >
              <ChatIcon />
            </IconButton>
          </Tooltip>
          <AppTopBarProfileMenu />
        </Stack>
      </ToolbarBioplan>
    </AppBarBioplan>
  );
};

interface StyledProps extends AppBarProps {
  maxHeight?: number;
}

export const AppBarBioplan = styled(AppBar)<StyledProps>(({theme, maxHeight}) => ({
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  '.MuiToolbar-root': {
    minHeight: theme.spacing(6),
    maxHeight,
  },
}));

export const ToolbarBioplan = styled(Toolbar)(({theme}) => ({
  color: theme.palette.text.primary,
}));
